module.exports = ".version_li {\n    padding-top: 13px;\n    padding-right: 15px;\n    padding-bottom: 12px;\n    padding-left: 15px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main